import { useSearchParams } from 'react-router-dom';

export function SubscribeSuccessPage() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const reason = searchParams.get('reason');

  const isError = status === 'error';

  return (
    <div className="w-full px-10">
      <div className="flex h-[85px] items-center">
        <h1 className="text-header-1 my-4 flex-grow truncate leading-none" title="Subscription">
          {isError ? 'Subscription Issue' : 'Subscription Successful'}
        </h1>
      </div>
      <div className="rounded-lg bg-white p-8 shadow-sm">
        <div className="flex flex-col items-center text-center">
          {isError ? (
            <>
              <div className="mb-6">
                <svg className="mx-auto h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <p className="text-body-1 text-lynch-500 mb-4">
                There was an issue processing your subscription.
                {reason && <span className="block mt-2 text-sm text-gray-500">Reason: {reason}</span>}
              </p>
              <p className="text-sm text-lynch-400">Please contact support if this issue persists.</p>
            </>
          ) : (
            <>
              <div className="mb-6">
                <svg className="mx-auto h-16 w-16 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <p className="text-body-1 text-lynch-500 mb-4">
                Thank you! Your subscription may take a minute or two to apply.
              </p>
            </>
          )}

          <a
            href="/account/plan"
            className="mt-6 inline-block rounded bg-dodger-blue-500 px-6 py-2 text-white hover:bg-dodger-blue-600"
          >
            Go to Plan Details
          </a>
        </div>
      </div>
    </div>
  );
}
